const styles = {
  container: {
    mb: 2,
  },
};
export default styles;
